import React from 'react';
import { useReactFlow } from '@xyflow/react';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import { baseEventWidth } from '../constants';

export default function BedContextMenu({
  id,
  top,
  left,
  right,
  bottom,
  onPaneClick,
  ...props
}) {
  const { getNode } = useReactFlow();
  const { updateNodeF, setShowComments, setOrders, setRecalculateHousePositions,
    updateNodesF, nodes, removeNode, setOrder, setShowRelatedOrdersMenu,
    setShowManageRelatedOrdersMenu, setHouseOrders, edges, addNodesF,
    setShowAccommodationPrefixDialog, initOrders, setInitOrders,
    relatedGroups, setRelatedGroups } = useAccomodationDiagram();
  const node = getNode(id);
  console.log(node);

  const handleCheckOut = (temporary = false) => {
    const extractedOrder = { ...node.data.order };
    if (temporary) {
      extractedOrder.temporary = true;
    } else {
      Reflect.deleteProperty(extractedOrder, 'temporary');
    }
    Reflect.deleteProperty(node.style, 'border');
    node.data = {
      ...node.data,
      order: null
    };
    setTimeout(() => {
      updateNodeF(node);
    }, 50);
    setRecalculateHousePositions([node.data.houseId]);
    setOrders(prevOrders => [extractedOrder, ...prevOrders]);
    if (!initOrders.find(o => o.id == extractedOrder.id)) {
      setInitOrders(prevOrders => [extractedOrder, ...prevOrders]);
    }
    onPaneClick();
  };

  const handleLeaveRelatedGroup = () => {
    const node = getNode(id);
    const newOrder = node.data.order;
    Reflect.deleteProperty(newOrder, 'relatedGroup');
    node.data = {
      ...node.data,
      order: newOrder
    };
    const newRelatedGroups = relatedGroups.map(rg => ({ ...rg, orders: [...rg.orders.filter(o => o !== newOrder.identifier)] }));
    setRelatedGroups(newRelatedGroups);

    setTimeout(() => {
      updateNodeF(node);
    }, 50);
    setRecalculateHousePositions([node.data.houseId]);
    onPaneClick();
  };

  const handleCheckOutRelatedGroup = (temporary = false) => {
    const extractedOrders = [];
    const nodesToUpdate = [];
    const housesToRecalculateIds = [];
    // W relatedNodes jest też ten wybrany node
    const relatedNodes = nodes.filter(n => n.data?.order?.relatedGroup?.id == node.data.order.relatedGroup.id);
    relatedNodes.map(relNode => {
      if (temporary) {
        extractedOrders.push({ ...relNode.data.order, temporary: true });
      } else {
        const newOrder = { ...relNode.data.order };
        Reflect.deleteProperty(newOrder, 'temporary');
        extractedOrders.push(newOrder);
      }
      relNode.data = {
        ...relNode.data,
        order: null
      };
      nodesToUpdate.push(relNode);
      if (!housesToRecalculateIds.includes(relNode.data.houseId)) {
        housesToRecalculateIds.push(relNode.data.houseId);
      }
    });
    updateNodesF(nodesToUpdate);
    setRecalculateHousePositions(housesToRecalculateIds);
    // Może być, że była już grupa, ale dodano do niej 1 zamówienie i wtedy ono może być na liście initOrders jeszcze
    const groupOrdersIds = extractedOrders.map(o => o.id);
    const ordersToInitOrders = [];
    extractedOrders.map(eo => {
      const foundOrder = initOrders.find(io => io.id == eo.id);
      if (!foundOrder) {
        ordersToInitOrders.push(eo);
      }
    });
    if (ordersToInitOrders.length > 0) {
      setInitOrders(prevOrders => [...ordersToInitOrders, ...prevOrders]);
    }
    setOrders(prevOrders => [...extractedOrders, ...prevOrders]);
    onPaneClick();
  };

  const handleRemoveBed = () => {
    removeNode(node.id);
    const currentEventChildrenNodes = nodes.filter(n => n.parentId === node.parentId);
    // Jak wykrywamy, że node z tą imprezą ma być pusty, to usuwamy go
    if (currentEventChildrenNodes.length === 1) {
      removeNode(node.parentId);
    }
    setRecalculateHousePositions([node.data.houseId]);
    onPaneClick();
  };

  const handleOpenRelatedOrdersMenu = () => {
    const houseOrders = nodes.filter(n => n.data.houseId == node.data.houseId && n.type == 'BedNode' && n.data.order).map(n => n.data.order);
    const commonEdge = edges.find(e => e.target == node.data.houseId || e.source == node.data.houseId);
    if (commonEdge) {
      const studioHouseId = commonEdge.target == node.data.houseId ? commonEdge.source : commonEdge.target;
      const studioOrders = nodes.filter(n => n.data.houseId == studioHouseId && n.type == 'BedNode' && n.data.order).map(n => n.data.order);
      setHouseOrders([...houseOrders, ...studioOrders]);
    } else {
      setHouseOrders(houseOrders);
    }
    setOrder(node.data.order);
    setShowRelatedOrdersMenu(true);
    onPaneClick();
  };

  const handleOpenManageRelatedOrdersMenu = () => {
    const houseOrders = nodes.filter(n => n.data.houseId == node.data.houseId && n.type == 'BedNode' && n.data.order).map(n => n.data.order);
    const commonEdge = edges.find(e => e.target == node.data.houseId || e.source == node.data.houseId);
    if (commonEdge) {
      const studioHouseId = commonEdge.target == node.data.houseId ? commonEdge.source : commonEdge.target;
      const studioOrders = nodes.filter(n => n.data.houseId == studioHouseId && n.type == 'BedNode' && n.data.order).map(n => n.data.order);
      setHouseOrders([...houseOrders, ...studioOrders]);
    } else {
      setHouseOrders(houseOrders);
    }
    setOrder(node.data.order);
    setShowManageRelatedOrdersMenu(true);
    onPaneClick();
  };

  const handleUnpinBed = () => {
    const emptyEventNode = nodes.filter(n => n.id === `${node.data.houseId}E`);
    // Jak wyniesie 1 to znaczy że odpinamy ostatnie łóżko z tej imprezy i należy ją usunąć
    const currentEventNodeChildrenCount = nodes.filter(n => n.parentId === node.parentId).length;
    if (emptyEventNode.length > 0) {
      // Znaleziono pustą imprezę więc przypisujemy łóżko do niej
      const updatedNode = { ...node, parentId: emptyEventNode[0].id };
      Reflect.deleteProperty(updatedNode.data, 'eventGroup');
      Reflect.deleteProperty(updatedNode.data, 'eventId');
      Reflect.deleteProperty(updatedNode.data, 'eventName');
      Reflect.deleteProperty(updatedNode.data, 'accommodationPrefix');
      removeNode(node.id);
      if (currentEventNodeChildrenCount === 1) {
        removeNode(node.parentId);
      }
      addNodesF([updatedNode]);
    } else {
      // Tworzymy nową pustą imprezę
      const houseNode = nodes.filter(n => n.id == node.data.houseId)[0];
      const emptyEventNode = prepareEmptyEventNode(houseNode);
      const updatedNode = { ...node, parentId: emptyEventNode.id };
      Reflect.deleteProperty(updatedNode.data, 'eventGroup');
      Reflect.deleteProperty(updatedNode.data, 'eventId');
      Reflect.deleteProperty(updatedNode.data, 'eventName');
      Reflect.deleteProperty(updatedNode.data, 'accommodationPrefix');
      removeNode(node.id);
      if (currentEventNodeChildrenCount === 1) {
        removeNode(node.parentId);
      }
      addNodesF([emptyEventNode, updatedNode]);
    }
    setRecalculateHousePositions([node.data.houseId]);
    onPaneClick();
  };

  const prepareEmptyEventNode = houseNode => {
    const eventHeight = houseNode.style.height - 28;
    const emptyEventNode = {
      id: `${houseNode.id}E`,
      position: {
        x: (houseNode.style.width - baseEventWidth) / 2,
        y: (houseNode.style.height - eventHeight) / 1.5
      },
      data: { houseId: houseNode.id,
        ageRangeNodeDataId: node.data.ageRangeNodeDataId,
        ageRangeId: node.data.ageRangeId,
        eventId: '0000',
        eventName: 'Nie przypisano' },
      style: { width: baseEventWidth, height: eventHeight },
      parentId: houseNode.id,
      extent: 'parent',
      className: 'light',
      type: 'EventNode',
      draggable: false
    };

    return emptyEventNode;
  };

  return (
    <div
      style={{ top, left, right, bottom }}
      className="context-menu"
      {...props}
    >
      <button onClick={() => handleCheckOut(false)} disabled={!node.data.order || node.data.order.relatedGroup}>Wykwateruj</button>
      <button onClick={() => handleCheckOut(true)} disabled={!node.data.order || node.data.order.relatedGroup}>Wykwateruj na chwilę</button>
      <button onClick={() => handleCheckOutRelatedGroup(false)} disabled={!node.data.order || !node.data.order.relatedGroup}>Wykwateruj całą powiązaną grupę</button>
      <button onClick={() => handleCheckOutRelatedGroup(true)} disabled={!node.data.order || !node.data.order.relatedGroup}>Wykwateruj całą powiązaną grupę na chwilę</button>
      <button onClick={handleLeaveRelatedGroup} disabled={!node.data.order || !node.data.order?.relatedGroup}>Opuść grupę zakwaterowania</button>
      {node.data.order ? !node.data.order?.relatedGroup ? <button onClick={handleOpenRelatedOrdersMenu}>Przypisz do grupy zakwaterowania</button>
        : <button onClick={handleOpenManageRelatedOrdersMenu}>Zarządzaj grupą zakwaterowania</button> : null}
      <button onClick={() => setShowComments(true)}>Pokaż komentarze</button>
      <button onClick={handleRemoveBed} disabled={node.data.order}>Usuń miejsce</button>
      <button onClick={handleUnpinBed} disabled={node.data.order || !node.data.eventId}>Odepnij od grupy</button>
      <button onClick={() => setShowAccommodationPrefixDialog(true)} disabled={!node.data.order}>Zmień prefix</button>
    </div>
  );
}
